import { useQuery, useMutation } from "@tanstack/react-query";
import { AppstoreAddOutlined } from "@ant-design/icons";
import { Button, Card, Col, Descriptions, Divider, Space, Row, Select, message, Modal } from "antd";
import axios from "axios";
import { useParams } from "react-router-dom";
import { hostname, ISO8601 } from "../hooks/useEndeavour";
import DataTable from "../components/DataTable";
import { useState, useRef } from "react";
import UserBindingNotificationsDrawer from "../components/UserBindingNotificationsDrawer";
import UserBindingNotificationsDetailDrawer from "../components/UserBindingNotificationsDetailDrawer";
import Status from "../components/Status";

export default function AppNotificationPage() {
  const { template_id } = useParams();
  const [forceUpdate, setForceUpdate] = useState(0);
  const [loading, setLoading] = useState(false);
  const userBindNotificationRef = useRef();
  const userBindNotificationDetailRef = useRef();

  const query = useQuery({
    queryKey: ["update campaign sort"],
    queryFn: () => {
      return axios
        .get(`${hostname}/pa-alliance/notification/template/${template_id}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        })
        .then((res) => {
          console.log(res.data.payload[0]);
          return res.data.payload[0];
        });
    },
  });
  const approve = useMutation({
    mutationFn: (value) => {
      setLoading(true);
      return axios
        .post(`${hostname}/pa-alliance/notification/template/approve`, value, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        })
        .then((res) => {
          if (res.status !== 200) {
            message.error("Approve Fail");
          } else {
            message.success("Approve Success");
            setForceUpdate(forceUpdate + 1);
          }
        })
        .catch((error) => {
          console.log(error.response?.data?.payload);

          // Extract limited users and tags from error response
          const payload = error.response?.data?.payload;
          const limitedTags = payload?.tag || [];
          const limitedUsers = payload?.user || [];

          // Create detailed error message
          let errorContent = "Approval failed due to limitations:\n\n";

          if (limitedTags.length > 0) {
            errorContent += "Limited Tags:\n";
            limitedTags.forEach((tag, index) => {
              errorContent += `${index + 1}. ${tag.name || tag.id || tag}\n`;
            });
            errorContent += "\n";
          }

          if (limitedUsers.length > 0) {
            errorContent += "Limited Users:\n";
            limitedUsers.forEach((user, index) => {
              errorContent += `${index + 1}. ${user.name || user.email || user.id || user}\n`;
            });
          }
          if (limitedUsers.length > 0) {
            // Show modal with detailed limitation information
            Modal.error({
              title: "Approval Failed - Limitations Detected",
              content: <div style={{ whiteSpace: "pre-line", maxHeight: "300px", overflow: "auto" }}>{errorContent}</div>,
              width: 600,
              okText: "Close",
            });
          }
        })
        .finally(() => {
          setLoading(false);
        });
    },
  });

  const drawerOnClick = (data) => {
    userBindNotificationRef.current.openDrawer(data);
  };
  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Card title="Notification Detail">
            <Descriptions column={3} layout="vertical">
              <Descriptions.Item label="Title">{query.data?.title}</Descriptions.Item>
              <Descriptions.Item label="Type">{query.data?.type}</Descriptions.Item>

              <Descriptions.Item label="Channel">{query.data?.channel}</Descriptions.Item>
              <Descriptions.Item label="Prompt">
                <pre style={{ margin: 0, whiteSpace: "pre-wrap" }}>{JSON.stringify(query.data?.prompt, null, 2)}</pre>
              </Descriptions.Item>
              <Descriptions.Item label="Body">{query.data?.body}</Descriptions.Item>
            </Descriptions>
          </Card>
        </Col>
        <Col span={24}>
          <Card title={"Notification Task"}>
            <UserBindingNotificationsDrawer
              ref={userBindNotificationRef}
              onChange={() => {
                setForceUpdate(forceUpdate + 1);
              }}
            />
            <UserBindingNotificationsDetailDrawer ref={userBindNotificationDetailRef} />
            <DataTable
              tableTitle={
                <Button type="primary" icon={<AppstoreAddOutlined />} style={{ marginBottom: 10 }} onClick={() => drawerOnClick(query.data)}>
                  Create Task
                </Button>
              }
              uri={`${hostname}/pa-alliance/notification/template/${query.data?.id}/task`}
              ForceUpdate={forceUpdate}
              tableColumns={[
                {
                  title: "Task ID",
                  render: (item) => {
                    return item.task_id;
                  },
                },
                {
                  title: "Notification ID",
                  render: (item) => {
                    return item.notification_id;
                  },
                },
                {
                  title: "Total User",
                  render: (item) => {
                    return item.total_user;
                  },
                },
                {
                  title: "Status",
                  render: (item) => {
                    return <Status value={item.status} />;
                  },
                },
                {
                  title: "Scheduled At",
                  render: (item) => {
                    return ISO8601(item.scheduled_at);
                  },
                },
                {
                  title: "Action",
                  render: (item) => {
                    return (
                      <Space>
                        <Button
                          type="primary"
                          onClick={() => {
                            userBindNotificationDetailRef.current.openDrawer({ ...query.data, task_id: item.task_id });
                          }}
                        >
                          Detail
                        </Button>
                        {item.status === "pending" && (
                          <Button
                            type="primary"
                            loading={loading}
                            onClick={() => {
                              approve.mutate(item);
                            }}
                          >
                            Approve
                          </Button>
                        )}
                      </Space>
                    );
                  },
                },
              ]}
            />
          </Card>
        </Col>
      </Row>
    </>
  );
}
